import { Component, OnInit } from '@angular/core';
import { CommonService } from "../../_services/common.service";
import { DatePipe } from '@angular/common'
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from "@angular/forms";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FlashMessagesService } from "angular2-flash-messages";
import { SettingService } from "../../_services/setting.service";
import { StaffComissionPayComponent } from '../staff-comission-pay/staff-comission-pay.component';
import * as Materialize from 'materialize-css';

@Component({
  selector: 'app-designer-commissions',
  templateUrl: './designer-commissions.component.html',
  styleUrls: ['./designer-commissions.component.css'],
  providers: [DatePipe]
})
export class DesignerCommissionsComponent implements OnInit {
  designerCommissionForm: FormGroup;
  private designerCommissionArray: Array<any> = [];
  public designerFormArray: FormArray;
  tabList: any[];
  id: any;
  public fpLists: Array<any> = [];
  public loading = false;
  public commissionOptions: any = {};
  public total = 0;
  public pagesToShow = 10;
  public page = 1;
  public current_page = 1;
  public limit = 10;
  public search: string = "";
  public sortColumnName = "date";
  public sortDirection = "asc";
  public filterText: string;
  public fromDate: string;
  public toDate: string;
  public commissionList: any = {};
  public addItems: string;
  public designerId: string;
  public userDetails: any = {};
  public disabled = true;

  constructor(private CommonService: CommonService,
    private formBuilder: FormBuilder,
    private _flashMessagesService: FlashMessagesService,
    private SettingService: SettingService,
    public dialog: MatDialog,
    private datepipe: DatePipe
  ) {
    this.tabList = [
      { key: "/commissions/printer-commissions", val: "Printer Commissions", cls: "" },
      { key: "/designer/designer-commissions", val: "Designer Commissions", cls: "active" }
    ];
    this.designerCommissionForm = formBuilder.group({
      designerFormArray: this.formBuilder.array([])

    });
    this.getListData();
  }

  ngOnInit() {
    this.addItems = "add";
    this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
    this.disabled = this.userDetails.type != "Shop" ? true : false;
  }

  openPayDialog(userType, comissionDueAmount, staffId, index): void {
    const dialogRef = this.dialog.open(StaffComissionPayComponent, {
      width: "500px",
      disableClose: true,
      data: {
        user_id: localStorage.getItem("userID"),
        manageData: { comission_amount: comissionDueAmount, user_type: userType, staff_id: staffId }
      }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result != "") {
        this.addItems = "";
        let balanceamount = comissionDueAmount - result;
        this.designerFormArray.controls[index].get('commissionDue').patchValue(balanceamount);
        this.getListData();
      }
    });
  }


  getListData = function () {
    this.loading = true;
    this.commissionOptions = {
      id: localStorage.getItem("userID"),
      limit: this.limit,
      page: this.page
    };
    if (this.filterText) {
      this.commissionOptions.search = this.filterText;
    }

    if (this.sortDirection) {
      this.commissionOptions.orderBy = this.sortColumnName;
      this.commissionOptions.direction = this.sortDirection;
    }
    if (this.fromDate) {
      this.commissionOptions.from_date = this.fromDate;
    }
    if (this.toDate) {
      this.commissionOptions.to_date = this.toDate;
    }
    if (this.designerId) {
      this.commissionOptions.designer_id = this.designerId;
    }

    this.CommonService.apiService(
      "POST",
      "commission/designers",
      this.commissionOptions
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          if (response.data) {
            this.designerCommissionArray = response.data.commission_records;
            this.commissionList = response.data;
            this.total = response.data.total;
            this.current_page = response.data.current_page;
            this.limit = response.data.limit;
            if (this.addItems == "add")
              this.createDesignerItems();
              console.log(this.commissionList.designer_id);
            this.commissionList.designer_id = this.commissionList.designer_id == null ? "" : this.commissionList.designer_id;
          }

        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }
  createDesignerItems() {
    this.designerFormArray = this.designerCommissionForm.get('designerFormArray') as FormArray;
    for (var i = 0; i < this.designerCommissionArray.length; i++) {
      let DesignerName = this.designerCommissionArray[i].first_name;
      if (this.designerCommissionArray[i].middle_name != null)
        DesignerName += ' ' + this.designerCommissionArray[i].middle_name;
      if (this.designerCommissionArray[i].last_name != null)
        DesignerName += ' ' + this.designerCommissionArray[i].last_name;
      if (this.designerCommissionArray[i].username != null)
        DesignerName += '(' + this.designerCommissionArray[i].username + ')';
      this.designerFormArray.push(this.formBuilder.group({
        name: DesignerName,
        designer_id: this.designerCommissionArray[i].designer_id,
        front: [this.designerCommissionArray[i].commission_amount.front, Validators.required],
        back: [this.designerCommissionArray[i].commission_amount.back, Validators.required],
        right: [this.designerCommissionArray[i].commission_amount.right, Validators.required],
        left: [this.designerCommissionArray[i].commission_amount.left, Validators.required],
        commissionDue: this.designerCommissionArray[i].due_commission,
        currentMonth: this.designerCommissionArray[i].current_month_commission,
        yearToDate: this.designerCommissionArray[i].year_to_date_commission,
        totalCommission: this.designerCommissionArray[i].total_commission,
        totalPaidCommission: this.designerCommissionArray[i].total_paid_commission,
      })
      );

    }
  }
  isFieldValid(field: string) {
    return (
      !this.designerCommissionForm.get(field).valid &&
      this.designerCommissionForm.get(field).touched
    );
  }
  onSubmit = function () {
    let formarray = {};
    this.designerCommissionForm.get('designerFormArray').value.forEach(function (element, index) {
      formarray[element.designer_id] = {
        'front': element.front,
        'back': element.back,
        'right': element.right,
        'left': element.left
      };
    });

    let options = {
      designer_commission: formarray
    };

    this.SettingService.setSetting(options).subscribe(
      (response: any) => {
        if (response.status === true) {
          this._flashMessagesService.show('Designer commissions saved successfully!', { cssClass: 'alert-success', timeout: 5000 });
        }
      },
      err => {
        console.log("Error =", err);
        this._flashMessagesService.show(err, { cssClass: 'alert-warning', timeout: 5000 });
      }
    );
  };

  goToPage(n: number): void {
    this.addItems = "";
    this.page = n;
    this.getListData();
  }

  onNext(): void {
    this.addItems = "";
    this.page++;
    this.getListData();
  }

  onPrev(): void {
    this.addItems = "";
    this.page--;
    this.getListData();
  }
  goSort($event) {
    this.addItems = "";
    this.sortColumnName = $event.columnName;
    this.sortDirection = $event.sortDirection;
    this.getListData();
  }

  filterType(): void {
    this.addItems = "";
    this.page = 1;
    this.total = 0;
    this.getListData();
  }

  onFromDateChange(fromDate) {
    this.addItems = "";
    this.page = 1;
    this.fromDate = fromDate ? this.datepipe.transform(new Date(fromDate), 'MM/dd/yyyy') : '';
    this.getListData();
  }
  onToDateChange(toDate) {
    this.addItems = "";
    this.page = 1;
    this.toDate = toDate ? this.datepipe.transform(new Date(toDate), 'MM/dd/yyyy') : '';
    this.getListData();
  }

  clearFilter(): void {
    this.addItems = "";
    this.filterText = "";
    this.page = 1;
    this.total = 0;
    this.getListData();
  }

  onDesignerIdChange(selectedUserId) {
    this.addItems = "";
    this.designerId = selectedUserId;
    this.page = 1;
    this.getListData();
  }


}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-users/designer-commissions/designer-commissions.component.ts